import { GuidedTourStatus } from "lib/guidedTour";

import client from "./httpClient";

export const updateStatus = async (status: GuidedTourStatus): Promise<any> => {
  const data = await client("PUT", "/ui/guidedTourStatus", { status });

  return data;
};
